import { render, staticRenderFns } from "./LessonTestQuestionTree.vue?vue&type=template&id=3f22002c"
import script from "./LessonTestQuestionTree.vue?vue&type=script&lang=js"
export * from "./LessonTestQuestionTree.vue?vue&type=script&lang=js"
import style0 from "./LessonTestQuestionTree.vue?vue&type=style&index=0&id=3f22002c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../edeone/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports